'use client';

import Cookies from 'js-cookie';
import Script from 'next/script';
import { FC, useCallback } from 'react';
import { Button, ButtonProps } from './Buttons';

// TODO(amatlash): move to config
const CALENDLY_URL = 'https://calendly.com/brightway-franchise/welcome-call';
const CALENDLY_SCRIPT_URL =
	'https://assets.calendly.com/assets/external/widget.js';

const getUTM = () => {
	// return the first cookie that is found
	const firstCookie = (keys: string[]) =>
		keys.map((key) => Cookies.get(key)).find((value) => value);

	return {
		utmSource:
			firstCookie(['leadSourceId', 'utm_source', 'SourceId']) ?? 'Calendly',
		utmContent: firstCookie(['utm_content', 'REFERER']),
		utmCampaign: firstCookie(['utm_campaign', 'CampaignId']),
	};
};

const initPopupWidget = () => {
	const params = getUTM();

	(window as any).Calendly.initPopupWidget({
		url: `${CALENDLY_URL}`,
		utm: params,
	});
};

export const CalendlyButton: FC<ButtonProps> = (props) => {
	const onClick = useCallback(() => {
		props.onClick?.();
		initPopupWidget();
	}, [props.onClick]);

	return (
		<>
			<Script src={CALENDLY_SCRIPT_URL} />
			<Button {...props} onClick={onClick} />
		</>
	);
};
